import { Bars } from "react-loader-spinner";
import axios from "axios";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import Chart from "../../Chart/Chart";
import { authContext } from "../../Context/Authentication/authContext";
import { generateMonthCount, generateQuarterCount, mergeCompareData } from "../../util";
import {
  getAdjustedPredictionData,
  getAdjustedSentimentData,
  getAnticipatedPredictionData,
} from "../../Helpers/helpers";
import "./HomeSales.scss";
import { baseURL } from "../../config";
import WChart from "../../WhatIfAnalysis/Chart/Chart";

const HomeSales = () => {
  const { state }: any = useContext(authContext);
  const [chartData, setChartData]: any = useState(null);
  const [isAdjustedPrediction, setIsAdjustedPrediction]: any = useState(false);

  useEffect(() => {
    setChartData(null);
    if (state.filters.predictionsArray.length != 0) {
      setIsAdjustedPrediction(true);
      getAllPredictionData()
      // state.filters.predictionsArray.map((t: any) => {
      //   console.log(t);

      //   if (t == "Mortgage Rates") {
      //     if (
      //       state.filters.refreshAdjustedPredictionSubmit &&
      //       state.filters.zipcode?.length === 0
      //     ) {
      //       setIsAdjustedPrediction(true);
      //       getAdjustedPrediction();
      //     }
      //   } else if (t == "Consumer Sentiments(HPSI)") {
      //     if (
      //       state.filters.refreshAdjustedSentimentSubmitByConsumer &&
      //       state.filters.zipcode?.length === 0
      //     ) {
      //       setIsAdjustedPrediction(true);
      //       getAdjustedSentiment("consumer");
      //     }
      //   } else if (t == "Builder Sentiments(NAHB)") {
      //     if (
      //       state.filters.refreshAdjustedSentimentSubmitByBuilder &&
      //       state.filters.zipcode?.length === 0
      //     ) {
      //       setIsAdjustedPrediction(true);
      //       getAdjustedSentiment("builder");
      //     }
      //   }
      // });
    } 
    else if(state.filters.showAnticipatedGrowth && state.filters.zipcode?.length === 0){
      setIsAdjustedPrediction(true);
      getAnticipatedGrowth()
    }
      else {
      setIsAdjustedPrediction(false);
      if (state.filters.showInterval && state.filters.zipcode?.length === 0) {
        getHomeSalesByInterval();
      } else if (state.filters.zipcode?.length && state.filters.showInterval) {
        getHomeSalesZipcodeByInterval();
      } 
      else if (state.filters.showComparison && state.filters.zipcode?.length) {
        getHomeSalesZipCodeComparison();  
      } 
      else if (state.filters.zipcode?.length && !state.filters.showInterval) {
        getHomeSalesZipcode();
      }
      else if (state.filters.showComparison && state.filters.zipcode?.length === 0 ) {
        getHomeSalesComparison(); 
      }else {
        getHomeSalesCounty();
      }
    }
  }, [
    state.filters.years,
    state.filters.county,
    state.filters.zipcode,
    state.filters.value,
    state.filters.showInterval,
    state?.filters?.selectedType,
    state?.filters?.regionType,
    state?.filters?.neighborhood,
    state.filters.refreshAdjustedPredictionSubmit,
    state.filters.refreshAdjustedSentimentSubmitByConsumer,
    state.filters.refreshAdjustedSentimentSubmitByBuilder,
    state.filters.showComparison,
    state.filters.refreshAnticipatedPredictionSubmit ,
    state.filters.showAnticipatedGrowth
  ]);

  const getAllPredictionData=()=>{
    if (state.filters.predictionsArray.length != 0) {
      let mainarr: any = [];
      let res1: any = [];
      let res2: any = [];
      let res3: any = [];
    
      // Create an array of promises for each async call
      const promises = state.filters.predictionsArray.map(async (t: any) => {
        if (t == "Mortgage Rates") {
          const query = `${state.filters.state}/${state.filters.city[0]}/city`;
          let data = state.filters.adjustedPredictionValues;
          delete data.status;
          res1 = await getAdjustedPredictionData(query, data, "hs");
          console.log(res1, 'resp1');
        } else if (t == "Consumer Sentiments(HPSI)") {
          let type = 'consumer';
          const query = `${state.filters.state}/${state.filters.city[0]}/city`;
          let data =
            type === "consumer"
              ? state.filters.adjustedSentimentValuesByConsumer
              : state.filters.adjustedSentimentValuesByBuilder;
          delete data.status;
          res2 = await getAdjustedSentimentData(query, data, `hs/${type}`);
          console.log(res2, 'resp2');
        } else if (t == "Builder Sentiments(NAHB)") {
          let type = 'builder';
          const query = `${state.filters.state}/${state.filters.city[0]}/city`;
          let data =
            type === "consumer"
              ? state.filters.adjustedSentimentValuesByConsumer
              : state.filters.adjustedSentimentValuesByBuilder;
          delete data.status;
          res3 = await getAdjustedSentimentData(query, data, `hs/${type}`);
          console.log(res3, 'resp3');
        }
      });
    
      // Wait for all promises to resolve
      Promise.all(promises)
        .then(() => {
          if(res1.length>0){
            res1.forEach((item: any, index: any) => {
              mainarr.push({
                date: item.date,
                actual_predictions: item.actual_predictions,
                adjusted_prediction: res1[index]?.adjusted_prediction || "",
                consumer_adjusted_prediction: res2[index]?.adjusted_prediction || "",
                builder_adjusted_prediction: res3[index]?.adjusted_prediction || "",
              });
            });

          }
          else if(res2.length>0){
            res2.forEach((item: any, index: any) => {
              mainarr.push({
                date: item.date,
                actual_predictions: item.actual_predictions,
                adjusted_prediction: res1[index]?.adjusted_prediction || "",
                consumer_adjusted_prediction: res2[index]?.adjusted_prediction || "",
                builder_adjusted_prediction: res3[index]?.adjusted_prediction || "",
              });
            });

          }
          else if(res3.length>0){
            res3.forEach((item: any, index: any) => {
              mainarr.push({
                date: item.date,
                actual_predictions: item.actual_predictions,
                adjusted_prediction: res1[index]?.adjusted_prediction || "",
                consumer_adjusted_prediction: res2[index]?.adjusted_prediction || "",
                builder_adjusted_prediction: res3[index]?.adjusted_prediction || "",
              });
            });

          }

          console.log(mainarr);
          setChartData(mainarr)
        })
        .catch((error) => {
          console.error('Error occurred:', error);
        });
    }
    

  }

  const getAdjustedSentiment = async (type: string) => {
    const query = `${state.filters.state}/${state.filters.city[0]}/city`;
    let data =
      type === "consumer"
        ? state.filters.adjustedSentimentValuesByConsumer
        : state.filters.adjustedSentimentValuesByBuilder;
    delete data.status;
    const resp = await getAdjustedSentimentData(query, data, `hs/${type}`);
    console.log(chartData);

    if (chartData != null) {
      if (chartData[0].hasOwnProperty("value1")) {
        setChartData(resp);
      } else {
        const keys = Object.keys(resp[0]);
        console.log(chartData);
        chartData.forEach((mainItem: any) => {
          resp.forEach((newItem: any) => {
            if (mainItem.date === newItem.date) {
              mainItem[keys[keys.length - 1]] = newItem[keys[keys.length - 1]];
            }
          });
        });
        console.log(chartData);
        setChartData(chartData);
      }
    } else {
      // setChartData(resp);
      getAllPredictionData()
    }
  };

  const getAdjustedPrediction = async () => {
    const query = `${state.filters.state}/${state.filters.city[0]}/city`;
    let data = state.filters.adjustedPredictionValues;
    delete data.status;
    const resp = await getAdjustedPredictionData(query, data, "hs");
    console.log(chartData);
    if (chartData != null) {
      if (chartData[0].hasOwnProperty("value1")) {
        setChartData(resp);
      } else {
        const keys = Object.keys(resp[0]);
        console.log(chartData);
        chartData.forEach((mainItem: any) => {
          resp.forEach((newItem: any) => {
            if (mainItem.date === newItem.date) {
              mainItem[keys[keys.length - 1]] = newItem[keys[keys.length - 1]];
            }
          });
        });
        console.log(chartData);
        setChartData(chartData);
      }
    } else {
      // setChartData(resp);
      getAllPredictionData()
    }

    // setChartData(resp);
  };

  const getAnticipatedGrowth=async ()=>{
    let mainarr:any=[]
    let res=[]
    const query = `${state.filters.state}/${state.filters.city[0]}/city`;
    let data = state.filters.adjustedAnticipatedValues;
    delete data.status;
    res = await getAnticipatedPredictionData(query, data, "hs");
    if(res.length>0){
      res.forEach((item: any, index: any) => {
        mainarr.push({
          date: item.date,
          actual_predictions: item.actual_predictions,
          adjusted_prediction: res[index]?.adjusted_prediction || "",
        });
      });

    }
    console.log(mainarr);
    setChartData(mainarr)

  }
  

  const getHomeSalesCounty = async () => {
    const start = state.filters.years[0];
    const end = state.filters.years[1];
    try {
      const county = JSON.stringify(state.filters.county)
      .replace(/^\[|\]$/g, "") // Only removes the starting and ending square brackets
      .replaceAll('"', "'");
      const response = await axios.get(
        `${baseURL}getHsCounty?state=${
          state.filters.state
        }&county=${county}&startYear=${start}&endYear=${end}&flag=${state.filters.value.toLowerCase()}`
      );
      console.log(response)
      const data = generateChartData(response.data?.cube);
      console.log(data)
      setChartData(data);
    } catch (error) {
      console.log("error", error);
    }
  };

  
 const getHomeSalesComparison = async () => {
   const start = state.filters.years[0];
   const end = state.filters.years[1];
   try {
     const city = JSON.stringify(state.filters.city)
     .replace(/^\[|\]$/g, "") // Only removes the starting and ending square brackets
     .replaceAll('"', "'");
     const response1 = await axios.get(
       `${baseURL}getHomeSales?state=${state.filters.state}&city=${city}&startYear=${start}&endYear=${end}&flag=${state.filters.value.toLowerCase()}`
     );
     const response2 = await axios.get(
       `${baseURL}getHomeSalesComparision?state=${state.filters.state}&city=${city}&startYear=${start}&endYear=${end}&flag=${state.filters.value.toLowerCase()}`
     );
     const result = mergeCompareData(response1.data.cube[state.filters.city[0]], response2.data.cube[state.filters.city[0]],'homeSales');
     setChartData(result)
     // const data = generateChartData(response.data?.cube, 'ppsf');
     // setChartData(data);
   } catch (error) {
     console.log("error", error);
   }
 };

  const getHomeSalesZipcode = async () => {
    const start = state.filters.years[0];
    const end = state.filters.years[1];
    try {
      const zipcode = JSON.stringify(
        state.filters.zipcode.map((item: string) => item.split("_")[0])
      )
        .replace(/[\[\]']+/g, "")
        .replaceAll('"', "'");
      const response = await axios.get(
        `${baseURL}getHomeSalesZipcode?state=${
          state.filters.state
        }&zipcode=${zipcode}&startYear=${start}&endYear=${end}&flag=${state.filters.value.toLowerCase()}`
      );
      const data = generateZipChartData(response.data?.cube);
      setChartData(data);
    } catch (error) {
      console.log("error", error);
    }
  };
  const getHomeSalesZipCodeComparison = async () => {
    const start = state.filters.years[0];
    const end = state.filters.years[1];
    try {
      const zipcode = JSON.stringify(
        state.filters.zipcode.map((item: string) => item.split("_")[0])
      )
        .replace(/[\[\]']+/g, "")
        .replaceAll('"', "'");
      const response1 = await axios.get(
        `${baseURL}getHomeSalesZipcode?state=${
          state.filters.state
        }&zipcode=${zipcode}&startYear=${start}&endYear=${end}&flag=${state.filters.value.toLowerCase()}`
      );
      const response2 = await axios.get(
        `${baseURL}getHomeSalesZipcodeComparision?state=${
          state.filters.state
        }&zipcode=${zipcode}&startYear=${start}&endYear=${end}&flag=${state.filters.value.toLowerCase()}`)

        const result = mergeCompareData(response1.data.cube[state.filters.zipcode[0]], response2.data.cube[state.filters.zipcode[0]],'homeSales');
        setChartData(result)
    } catch (error) {
      console.log("error", error);
    }
  };


  const getHomeSalesZipcodeByInterval = async () => {
    const start = state.filters.years[0];
    const end = state.filters.years[1];
    try {
      const zipcode = JSON.stringify(
        state.filters.zipcode.map((item: string) => item.split("_")[0])
      )
        .replace(/[\[\]']+/g, "")
        .replaceAll('"', "'");
      const response = await axios.get(
        `${baseURL}getHomeSalesZipcodeInterval?state=${
          state.filters.state
        }&zipcode=${zipcode}&startYear=${start}&endYear=${end}&flag=${state.filters.value.toLowerCase()}`
      );
      const data = generateIntervalChartData(response.data?.cube);
      setChartData(data);
    } catch (error) {
      console.log("error", error);
    }
  };

  const getHomeSalesByInterval = async () => {
    const city = JSON.stringify(state.filters.city)
    .replace(/^\[|\]$/g, "") // Only removes the starting and ending square brackets
    .replaceAll('"', "'");
    const start = state.filters.years[0];
    const end = state.filters.years[1];
    try {
      const response = await axios.get(
        `${baseURL}getHomeSalesInterval?state=${
          state.filters.state
        }&city=${city}&startYear=${start}&endYear=${end}&flag=${state.filters.value.toLowerCase()}`
      );
      const data = generateIntervalChartData(response.data?.cube);
      setChartData(data);
    } catch (error) {
      console.log("error", error);
    }
  };

  const generateChartData = (apiData: any) => {
    try {
      const start = state.filters.years[0];
      const end = state.filters.years[1];
      const totalMonths = generateMonthCount(start, end);
      const data: any = [];
      for (let i = 0; i < totalMonths; i++) {
        let value: any = {};
        for (let j = 0; j < state.filters?.county?.length; j++) {
          if (apiData[state.filters.county[j]]?.length) {
            const date: any = moment(
              apiData[state.filters.county[j]][i]?.date
            ).format("YYYY-MM-DD");

            value = {
              ...value,
              date: date,
              [`value${j + 1}`]: apiData[state.filters.county[j]][i]?.homesales,
            };
          } else {
            continue;
          }
        }
        Object.keys(value)?.length > 0 && data.push(value);
      }
      return data;
    } catch (error) {
      console.log(error);
    }
  };

  const generateIntervalChartData = (apiData: any) => {
    try {
      const data: any = apiData.map((item: any) => {
        return {
          date: item?.date,
          value1: item?.homeSalesHigh,
          value2: item?.homeSalesLow,
          value3: item?.homeSales,
        };
      });
      return data;
    } catch (error) {
      console.log(error);
    }
  };

  const generateZipChartData = (apiData: any) => {
    try {
      const start = state.filters.years[0];
      const end = state.filters.years[1];
      const totalMonths = generateQuarterCount(start, end);
      const data: any = [];

      for (let i = 0; i < totalMonths; i++) {
        let value: any = {};
        for (let j = 0; j < state.filters?.zipcode?.length; j++) {
          if (
            apiData[state.filters.zipcode[j].split("_")[0]]?.length &&
            apiData[state.filters.zipcode[j].split("_")[0]][i]?.date
          ) {
            const date: any = moment(
              apiData[state.filters.zipcode[j].split("_")[0]][i]?.date
            ).format("YYYY-MM-DD");

            value = {
              ...value,
              date: date,
              [`value${j + 1}`]:
                apiData[state.filters.zipcode[j].split("_")[0]][i]?.homeSales,
            };
          } else {
            continue;
          }
        }
        Object.keys(value)?.length > 0 && data.push(value);
      }
      return data;
    } catch (error) {
      console.log(error);
    }
  };

  const getSelectValue=()=>{
    switch(state.filters.value){
      case 'Absolute':
        return 'Absolute'
      case 'growth':
          return ' Growth (Month on Month)'
      case 'trend':
            return 'Long Term Trend'
     case 'percentage':
              return 'Percentage'
      
    }
  }

  return (
    <div className="homesales-main prediction-chart">
      {chartData?.length && !isAdjustedPrediction ? (
        <div className="homesales-main__text">Monthly home sales {getSelectValue()}</div>
      ) : null}

      <div className="homesales-main__chartContainer">
        {chartData === null ? (
          <div className="homesales-main__chartContainer__isLoading">
            <Bars
              height="400"
              ariaLabel="bars-loading"
              wrapperClass="tab-spinner-progress-bar"
              visible={true}
            />
          </div>
        ) : chartData?.length ? (
          <>
            {isAdjustedPrediction ? (
              <WChart
                chartData={chartData}
                chartId={"hs-chart"}
                title="Adjusted HS Projection  "
                isMulti
                isPredition
                isSetToZoom
              />
            ) : (
              <Chart
                chartData={chartData}
                title={`Home sales ${
                  state.filters.value === "growth" ? "(% Growth (Month on Month))" : ""
                }`}
                city={state.filters.city}
                zipcode={state.filters.zipcode}
                showInterval={state.filters.showInterval}
                county={state.filters.county}
              />
            )}
          </>
        ) : (
          <div className="homesales-main__chartContainer__noData">
            No Data Available
          </div>
        )}
      </div>
    </div>
  );
};

export default HomeSales;
